<mat-card style="box-shadow: unset">
    <div class="box-content">
        <div class="button-card-sovrappossition">
            <ng-content select="[button]">
            </ng-content>
        </div>
    </div>
    <ng-container [ngSwitch]="actuator?.type">
        <ng-container *ngSwitchCase="sensorEventActuatorType.LINEAR_ACTUATOR">
            <ng-container
                *ngIf="actuator|transformValueByPredicateFunction:predicateGetLinearActuator as linearActuator">
                <mat-card-header>
                    <div mat-card-avatar>
                        <img src="assets/icon/sensor/curvaClimatica.svg" style="margin: 0">
                    </div>
                    <mat-card-title>Linear Actuator</mat-card-title>
                    <!-- Command Section -->
                    <mat-card-subtitle *ngIf="linearActuator.config?.objectId">
                        <strong>Command:</strong> {{ (linearActuator.config?.objectId! | getElementById:elements)?.name
                        || linearActuator.config?.objectId! }}
                        <br>
                        <small *ngIf="linearActuator.config?.command">{{
                            'possibleCommands.'+linearActuator.config?.command|translate }}</small>
                    </mat-card-subtitle>
                </mat-card-header>

                <mat-card-content>
                    <!-- X Section -->
                    <div class="linear-actuator-section"
                        *ngIf="linearActuator.config?.x_sourceId || linearActuator.config?.x_infoName">
                        <div class="section-header"><strong>X</strong></div>
                        <div *ngIf="linearActuator.config?.x_sourceId">
                            <span>{{ 'SensorEvent.name'|translate }}: {{ (linearActuator.config?.x_sourceId! |
                                getElementById:elements)?.name || linearActuator.config?.x_sourceId }}</span>
                        </div>
                        <div *ngIf="linearActuator.config?.x_infoName">
                            <span>{{ 'SensorEvent.sourceInfoName'|translate }}: {{ linearActuator.config?.x_infoName|sensorDataTraduction$|async
                                }}</span>
                        </div>
                    </div>

                    <!-- P1 Section -->
                    <div class="linear-actuator-section" *ngIf="linearActuator.config?.p1">
                        <div class="section-header"><strong>P1</strong></div>
                        <ng-container *ngIf="linearActuator.config?.p1?.value; else p1Source">
                            <div class="point-values">
                                <span>(x: {{ linearActuator.config?.p1?.value?.x ?? 'N/A' }}, y: {{
                                    linearActuator.config?.p1?.value?.y ?? 'N/A' }})</span>
                            </div>
                        </ng-container>
                        <ng-template #p1Source>
                            <div *ngIf="linearActuator.config?.p1?.source" class="point-sources">
                                <div *ngIf="linearActuator.config?.p1?.source?.x">
                                    X: {{ (linearActuator.config?.p1?.source?.x?.sensorId! |
                                    getElementById:elements)?.name || linearActuator.config?.p1?.source?.x?.sensorId }}
                                    <small *ngIf="linearActuator.config?.p1?.source?.x?.infoName"> ({{
                                        linearActuator.config?.p1?.source?.x?.infoName|sensorDataTraduction$|async }})</small>
                                </div>
                                <div *ngIf="linearActuator.config?.p1?.source?.y">
                                    Y: {{ (linearActuator.config?.p1?.source?.y?.sensorId! |
                                    getElementById:elements)?.name || linearActuator.config?.p1?.source?.y?.sensorId }}
                                    <small *ngIf="linearActuator.config?.p1?.source?.y?.infoName"> ({{
                                        linearActuator.config?.p1?.source?.y?.infoName|sensorDataTraduction$|async }})</small>
                                </div>
                            </div>
                        </ng-template>
                    </div>

                    <!-- P2 Section -->
                    <div class="linear-actuator-section" *ngIf="linearActuator.config?.p2">
                        <div class="section-header"><strong>P2</strong></div>
                        <ng-container *ngIf="linearActuator.config?.p2?.value; else p2Source">
                            <div class="point-values">
                                <span>(x: {{ linearActuator.config?.p2?.value?.x ?? 'N/A' }}, y: {{
                                    linearActuator.config?.p2?.value?.y ?? 'N/A' }})</span>
                            </div>
                        </ng-container>
                        <ng-template #p2Source>
                            <div *ngIf="linearActuator.config?.p2?.source" class="point-sources">
                                <div *ngIf="linearActuator.config?.p2?.source?.x">
                                    X: {{ (linearActuator.config?.p2?.source?.x?.sensorId! |
                                    getElementById:elements)?.name || linearActuator.config?.p2?.source?.x?.sensorId }}
                                    <small *ngIf="linearActuator.config?.p2?.source?.x?.infoName"> ({{
                                        linearActuator.config?.p2?.source?.x?.infoName|sensorDataTraduction$|async }})</small>
                                </div>
                                <div *ngIf="linearActuator?.config?.p2?.source?.y">
                                    Y: {{ (linearActuator.config?.p2?.source?.y?.sensorId! |
                                    getElementById:elements)?.name || linearActuator.config?.p2?.source?.y?.sensorId }}
                                    <small *ngIf="linearActuator.config?.p2?.source?.y?.infoName"> ({{
                                        linearActuator?.config?.p2?.source?.y?.infoName|sensorDataTraduction$|async }})</small>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </mat-card-content>
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="sensorEventActuatorType.EXT_SENSOR">
            <mat-card-header
                *ngIf="actuator?.config|transformValueByPredicateFunction:predicateGetElementExternal:elements as element">
                <div mat-card-avatar>
                    <mat-icon svgIcon="external_sensor" class="icon-size-medium">
                    </mat-icon>
                </div>
                <mat-card-title *ngIf="element?.target">{{ 'SensorEvent.targetExternal'|translate }}
                </mat-card-title>
                <mat-card-subtitle *ngIf="element?.target?.name">
                    {{ 'SensorEvent.name'|translate }}
                    : {{ element.target?.name }}
                </mat-card-subtitle>
                <mat-card-subtitle *ngIf="element?.targetCommandName">{{ 'SensorEvent.targetCommandName'|translate }}
                    : {{ ('possibleCommands.' + element?.targetCommandName)|translate }}
                </mat-card-subtitle>
                <mat-card-title *ngIf="element?.sensor">{{ 'SensorEvent.sensorExternal'|translate }}
                </mat-card-title>
                <mat-card-subtitle *ngIf="element?.sourceInfoName">{{ 'SensorEvent.name'|translate }}: {{
                    element.sensor?.name }}
                </mat-card-subtitle>
                <mat-card-subtitle *ngIf="element?.sourceInfoName">{{ 'SensorEvent.sourceInfoName'|translate }}
                    : {{ ('possibleValuesTypeElement.' + element?.sourceInfoName)|translate }}
                </mat-card-subtitle>
            </mat-card-header>
        </ng-container>
        <ng-container *ngSwitchCase="sensorEventActuatorType.RELAY">
            <mat-card-header
                *ngIf="actuator?.config|transformValueByPredicateFunction:predicateGetSwitch:switches:('NaN'|translate) as element">
                <div mat-card-avatar>
                    <mat-icon [color]="actuator|transformValueByPredicateFunction:predicateColorIconSwitch"
                        class="icon-size-medium">
                        power_settings_new
                    </mat-icon>
                </div>
                <mat-card-title>{{ element.name }}</mat-card-title>
                <mat-card-subtitle
                    *ngIf="actuator|transformValueByPredicateFunction:predicateRelayTraduction as traduction"> {{
                    traduction|translate }}
                </mat-card-subtitle>
            </mat-card-header>
        </ng-container>
        <ng-container *ngSwitchCase="sensorEventActuatorType.LIGHT">
            <ng-container *ngIf="actuator?.config|transformValueByPredicateFunction:predicateGetLight:lights as light">
                <mat-card-header>
                    <div mat-card-avatar>
                        <mat-icon
                            [ngClass]="{'text-color-primary':actuator|transformValueByPredicateFunction:predicateColorTypeLight}"
                            svgIcon="bulbs" class="icon-size-medium">
                        </mat-icon>
                    </div>
                    <mat-card-title *ngIf="light.name">{{ light?.name }}</mat-card-title>
                    <mat-card-subtitle>
                        <ng-container *ngIf="light.type==lightType.RANGE;else NoRange">
                            {{ 'SensorEvent.light.level'|translate:light }}
                        </ng-container>
                        <ng-template #NoRange>
                            {{ ('SensorEvent.light.status.' + light.status)|translate }}
                        </ng-template>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-footer *ngIf="light.type==lightType.RANGE">
                    <ng-container>
                        <div class="w100 container-box-color-level background-contrast">
                            <div [ngStyle]="{width:light.level+'%'}" class="background-color-primary box-color-level">
                            </div>
                        </div>
                    </ng-container>
                </mat-card-footer>
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="sensorEventActuatorType.SHUTTER">
            <ng-container
                *ngIf="actuator?.config|transformValueByPredicateFunction:predicateGetShutter:shutters as shutter">
                <mat-card-header>
                    <div mat-card-avatar>
                        <mat-icon svgIcon="blinds" class="icon-size-medium "
                            [ngClass]="{'text-color-primary':actuator|transformValueByPredicateFunction:predicateColorTypeShutter}">
                        </mat-icon>
                    </div>
                    <mat-card-title *ngIf="shutter.name">{{ shutter?.name }}</mat-card-title>
                    <mat-card-subtitle>
                        <ng-container *ngIf="shutter.type==shutterType.RANGE;else NoRange">
                            {{ 'SensorEvent.shutter.level'|translate:shutter }}
                        </ng-container>
                        <ng-template #NoRange>
                            {{ ('SensorEvent.shutter.status.' + shutter.status)|translate }}
                        </ng-template>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-footer *ngIf="shutter.type==shutterType.RANGE">
                    <ng-container>
                        <div class="w100 container-box-color-level background-contrast">
                            <div [ngStyle]="{width:shutter.level+'%'}" class="background-color-primary box-color-level">
                            </div>
                        </div>
                    </ng-container>
                </mat-card-footer>
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="sensorEventActuatorType.COMMAND">
            <ng-container
                *ngIf="actuator?.config|transformValueByPredicateFunction:predicateGetCommand:commands as command">
                <mat-card-header>
                    <div mat-card-avatar>
                        <mat-icon class="icon-size-medium "
                            [ngClass]="{'text-color-primary':actuator|transformValueByPredicateFunction:predicateColorTypeShutter}">
                            settings
                        </mat-icon>
                    </div>
                    <mat-card-title *ngIf="command.name">{{ command?.name }}</mat-card-title>
                    <mat-card-subtitle>
                        @if (command.commandType == 'BOOL') {
                        <ng-container *ngIf="command.possibleCommand">
                            {{ 'possibleCommands.' + command.possibleCommand|translate }}&nbsp;{{ (command.value == 1 ?
                            'on' : 'off')|translate }}
                        </ng-container>
                        } @else {
                        {{ 'possibleCommands.' + command.possibleCommand|translate }}&nbsp;{{ command.value }}

                        }
                    </mat-card-subtitle>
                </mat-card-header>
            </ng-container>
        </ng-container>
    </ng-container>
</mat-card>